import React from 'react';
import { Building2, ArrowRight, CheckCircle2 } from 'lucide-react';
interface WelcomeScreenProps {
  orgName: string;
  onOrgNameChange: (name: string) => void;
  onAddFirstClient: () => void;
  onSkip: () => void;
}
export function WelcomeScreen({
  orgName,
  onOrgNameChange,
  onAddFirstClient,
  onSkip
}: WelcomeScreenProps) {
  return <div className="flex-1 flex items-center justify-center p-6 min-h-[calc(100vh-64px)] animate-in fade-in duration-500" data-id="element-806">
      <div className="w-full max-w-xl text-center" data-id="element-807">
        <div className="w-16 h-16 bg-astro-green/10 rounded-full flex items-center justify-center mx-auto mb-6 ring-1 ring-astro-green/30 shadow-[0_0_30px_rgba(34,197,94,0.15)]" data-id="element-808">
          <CheckCircle2 size={32} className="text-astro-green" data-id="element-809" />
        </div>

        <h1 className="text-4xl font-bold text-white mb-3 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-810">
          Welcome to Astrolayb
        </h1>
        <p className="text-lg text-astro-text-secondary mb-10" data-id="element-811">
          Your organization has been created. Let's get you set up.
        </p>

        <div className="bg-astro-card border border-astro-border rounded-xl p-8 mb-8 text-left shadow-2xl" data-id="element-812">
          <div className="flex items-center justify-between mb-6" data-id="element-813">
            <label className="text-sm font-medium text-astro-text-secondary" data-id="element-814">
              Organization Name
            </label>
            <span className="px-2 py-0.5 rounded-full bg-astro-green/10 text-astro-green text-[10px] font-bold uppercase tracking-wider border border-astro-green/20" data-id="element-815">
              Trial
            </span>
          </div>

          <div className="relative mb-2" data-id="element-816">
            <Building2 size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-astro-text-secondary" data-id="element-817" />

            <input type="text" value={orgName} onChange={e => onOrgNameChange(e.target.value)} className="w-full bg-[#0a0e14] border border-astro-border rounded-lg pl-12 pr-4 py-3 text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 focus:ring-1 focus:ring-astro-green/50 transition-all" data-id="element-818" />

          </div>
          <p className="text-xs text-astro-text-secondary/60 mb-8" data-id="element-819">
            You can change this anytime in Settings.
          </p>

          <button onClick={onAddFirstClient} className="w-full py-3.5 bg-astro-green text-black font-bold rounded-lg hover:bg-astro-green-dark transition-all shadow-[0_0_20px_rgba(34,197,94,0.2)] hover:shadow-[0_0_30px_rgba(34,197,94,0.4)] flex items-center justify-center gap-2 group" data-id="element-820">

            Add Your First Client{' '}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-821" />

          </button>
        </div>

        <button onClick={onSkip} className="text-sm text-astro-text-secondary hover:text-white transition-colors" data-id="element-822">

          Skip for now — go to dashboard
        </button>
      </div>
    </div>;
}